import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash/fp';
import cns from 'classnames';

import CloseIcon from 'components/icons/CloseIcon.com.svg';
import AdCard from 'components/AdCard';
import Pagination from 'components/Pagination';

import cn from './styles.local.less';

const AD_CARD_TRACK_AS = 'favorite-overview-ad-card';

export default class AdList extends PureComponent {
  static propTypes = {
    items: PropTypes.array.isRequired,
    pagination: PropTypes.object.isRequired,
    withFavorite: PropTypes.bool.isRequired,
    withDislike: PropTypes.bool.isRequired,
    loadPage: PropTypes.func.isRequired,
    onToggleAdFavoriteClick: PropTypes.func,
    onToggleAdDislikeClick: PropTypes.func,
    onRemoveFavoriteForUnpublishedAd: PropTypes.func,
  };

  static defaultProps = {
    onToggleAdFavoriteClick: noop,
  };

  render() {
    const {
      items,
      pagination,
      loadPage,
      withFavorite,
      withDislike,
      onToggleAdFavoriteClick,
      onToggleAdDislikeClick,
      onRemoveFavoriteForUnpublishedAd,
    } = this.props;

    return (
      <div data-qa-selector="ad-list" className={cn.root}>
        <ul className={cn.list}>
          {items.map((ad) => (
            <li
              key={ad.id}
              className={cns(cn.item, { [cn.overlay]: !ad.published })}
            >
              <AdCard
                {...ad}
                className={cns({ [cn.unpublishedAd]: !ad.published })}
                imageDisplayType="secondary"
                trackAs={AD_CARD_TRACK_AS}
                withSellerContactInfo
                withSubtitle
                withMerchantInfo
                withFavorite={ad.published && withFavorite}
                withDislike={ad.published && withDislike}
                onToggleAdFavoriteClick={onToggleAdFavoriteClick}
                onToggleAdDislikeClick={onToggleAdDislikeClick}
              />

              {!ad.published ? (
                <CloseIcon
                  className={cn.closeIcon}
                  onClick={() => onRemoveFavoriteForUnpublishedAd(ad.id)}
                />
              ) : null}
            </li>
          ))}
        </ul>
        {pagination ? (
          <Pagination pagination={pagination} loadPage={loadPage} />
        ) : null}
      </div>
    );
  }
}
